<template>
  <div class="container mol-typical-page-container-20" :class="{'showing-message-banner': false}">

    <LoadingSpinner v-if="!club"></LoadingSpinner>


    <!--    you're not logged in -->
    <div v-else-if="!loggedIn">
      <ClubCard :club="club"></ClubCard>
      <div class="card card-body call-to-action-card">
        <div class="invite-text">
          <h4>sign in or sign up to join</h4>
        </div>
        <SignIn></SignIn>
      </div>
    </div>

    <!--    you're already a member -->
    <div v-else-if="member">
      <ClubCard :club="club" :my_membership="clubInfo.my_membership"></ClubCard>
      <h4 style="text-align: center;" >You're already a member of {{club.name}}</h4>
    </div>

    <!--    you've already applied for membership, awaiting a response -->
    <div class="pending-member-wrapper" v-else-if="pendingMember">
      <span class="badge rounded-pill"><i class="fa fa-hourglass-1" aria-hidden="true"></i> pending approval</span>
      <ClubCard :club="club" :my_membership="clubInfo.my_membership"></ClubCard>
      <h4 style="text-align: center;" >You're request to join {{club.name}} is pending.</h4>
    </div>

    <!--    you've a free-tier user and already a member of another club -->
    <div v-else-if="!userStore.isFullMember() && memberOfAnotherClub">
      <ClubCard :club="club"></ClubCard>
      <h4 style="text-align: center;">You're already in another Oscar Pool</h4>
      <p style="text-align: center;">If you're interested in joining multiple <span class="no-wrap">Oscar Pools</span>, consider becoming a full member.</p>
    </div>

    <!--    you've a free-tier user and already a pending member of another club -->
    <div v-else-if="!userStore.isFullMember() && pendingMemberOfAnotherClub">
      <ClubCard :club="club"></ClubCard>
      <h4 style="text-align: center;">You're already a pending member of another Oscar Pool</h4>
      <p style="text-align: center;">If you're interested in joining multiple <span class="no-wrap">Oscar Pools</span>, consider becoming a full member.</p>
    </div>

    <!--    trivial case: i'm logged in, and i'm not already a member -->
    <div v-else class="card card-body">
      <ClubCard :club="club"></ClubCard>
      <div class="text-center">
        <div class="join-text">
          <p>send request to join</p>
          <p style="" class="club-name">{{club.name}}</p>
        </div>
        <button class="btn btn-sm btn-primary me-sm-2" type="button" @click="sendJoinRequest()">
          <i class="fa fa-user-plus"></i> send
        </button>
      </div>
    </div>

  </div>
</template>


<script>
import axios from "axios";
import {userStore} from "@/userStore";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import ClubCard from "@/components/clubs/cards/ClubCard.vue";
import SignIn from "@/components/auth/SignIn.vue";


export default {
  name: "ClubJoinPage",
  components: {SignIn, ClubCard, LoadingSpinner },
  props: ['club_id'],
  data() {
    return {
      clubInfo: null,
      myClubsArray: null,
    }
  },

  computed: {
    userStore() {
      return userStore;
    },
    club() {
      return this.clubInfo?.club;
    },
    loggedIn() {
      return !!userStore.user;
    },
    member() {
      return ( this.clubInfo?.my_membership && (this.clubInfo.my_membership.role !== 'pending') );
    },
    pendingMember() {
      return ( this.clubInfo?.my_membership?.role === 'pending' );
    },
    memberOfAnotherClub() {
      return this.myClubsArray && this.myClubsArray.some(club => {
        if ( club._id === this.clubInfo.club._id ) {
          return false;
        }
        return ( club.my_membership.role !== 'pending' );
      });
    },
    pendingMemberOfAnotherClub() {
      return this.myClubsArray && this.myClubsArray.some(club => {
        if ( club._id === this.clubInfo.club._id ) {
          return false;
        }
        return ( club.my_membership.role === 'pending' );
      });
    }
  },

  async created() {
    return Promise.all([
      axios.get(`/api/club/${this.club_id}/club-info`),
      axios.get('/api/club/my-clubs')
    ])
        .then(([clubInfoResponse, myClubsResponse]) => {
          this.clubInfo = clubInfoResponse.data;
          this.myClubsArray = myClubsResponse.data;
          //console.log('clubInfo', this.clubInfo);
          //console.log('myClubsArray', this.myClubsArray);
          if ( this.member ) {
            this.$router.push({name: 'OscarPoolProfilePage', params: {club_id: this.clubInfo.club._id}});
          }
        })
        .catch(err => {
          console.log(err);
          this.$router.push({name: 'OscarPoolsPage'}); // todo: maybe add a new ClubNotFound page?
        });
  },

  methods: {
    async sendJoinRequest() {
      axios.post(`/api/club/join`, { club_id: this.club_id })
          .then(response => {
            this.clubInfo = response.data;
            //console.log('clubInfo', this.clubInfo);
          })
          .catch(err => {
            console.log(err);
          });
    }
  }
}
</script>


<style scoped>

.mol-typical-page-container-20 {
  padding-bottom: 50px;
}

.join-text {
  text-align: center;
  margin-bottom: 10px;

  p {
    margin-bottom: 0px;

    &.club-name {
      font-weight: 500;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
  }
}

.call-to-action-card {
  border-width: 2px;
  margin-right: 20px;
  margin-left: 20px;
  margin-bottom: 20px;

  .invite-text {
    text-align: center;
    margin-top: 0.75em;
    margin-bottom: 1.5em;
  }
}

.pending-member-wrapper {
  position: relative;

  .badge {
    background-color: var(--mol-color-gold);
    position: absolute;

    top: -0.75em;
    left: 0.75em;

    z-index: 1;
    i {
      font-size: x-small;
    }
  }
}


</style>